import { Outlet } from '@tanstack/react-router';

import { Toaster } from '@/shared/ui/misc';

/** Top of the component tree: every page plus the app-wide toaster. */
export function RootLayout() {
  return (
    <>
      <Outlet />
      <Toaster />
    </>
  );
}
